/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Invite_Confirm_MessageInputs */

const cs_users_invite_confirm_message = /** @type {(inputs: Users_Invite_Confirm_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každý vybraný uživatel dostane e-mail s odkazem pro nastavení hesla (platí 7 dní). Předchozí nepoužité pozvánky přestanou platit.`)
};

const en_users_invite_confirm_message = /** @type {(inputs: Users_Invite_Confirm_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each selected user gets an e-mail with a link to set their password (valid 7 days). Earlier unused invitations stop working.`)
};

/**
* | output |
* | --- |
* | "Each selected user gets an e-mail with a link to set their password (valid 7 days). Earlier unused invitations stop working." |
*
* @param {Users_Invite_Confirm_MessageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_invite_confirm_message = /** @type {((inputs?: Users_Invite_Confirm_MessageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Invite_Confirm_MessageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_invite_confirm_message(inputs)
	return cs_users_invite_confirm_message(inputs)
});